//Reset data
export const RESET = "INSTITUTION_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "INSTITUTION_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INSTITUTION_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INSTITUTION_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INSTITUTION_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "INSTITUTION_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INSTITUTION_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INSTITUTION_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INSTITUTION_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INSTITUTION_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "INSTITUTION_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "INSTITUTION_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INSTITUTION_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INSTITUTION_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INSTITUTION_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "INSTITUTION_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "INSTITUTION_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INSTITUTION_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INSTITUTION_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INSTITUTION_SHOW_SET_MODAL_TYPE"